import { __makeTemplateObject, __rest, __values } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { SuccessIcon } from './SuccessIcon';
import { WarningIcon } from './WarningIcon';
import { ErrorIcon } from './ErrorIcon';
/* Using this function and returning the status as a string,
 * which is used as a className is not necessarily the way to go,
 * but for now, for the quick implementation, it's easy to use in both
 * Mui components and vanilla components. Should be rethought about
 * when making a more proper, consistent implementation. */
/** returns the status and statusAdornment, the InputStatusProps itself and the restProps */
export function extractInputStatusFromProps(props) {
    inputStatusChecker(props);
    var status;
    var statusAdornment;
    var error = props.error, warning = props.warning, success = props.success, withFeedbackIcon = props.withFeedbackIcon, restProps = __rest(props, ["error", "warning", "success", "withFeedbackIcon"]);
    if (error) {
        statusAdornment = React.createElement(SErrorIcon, null);
        status = 'error';
    }
    else if (warning) {
        statusAdornment = React.createElement(SWarningIcon, null);
        status = 'warning';
    }
    else if (success) {
        statusAdornment = React.createElement(SSuccessIcon, null);
        status = 'success';
    }
    return {
        status: status,
        statusAdornment: withFeedbackIcon ? statusAdornment : undefined,
        error: error,
        warning: warning,
        success: success,
        withFeedbackIcon: withFeedbackIcon,
        restProps: restProps,
    };
}
export var _ErrorLogMessage = 'Cannot have multiple statuses set for input status props. Only using 1 status, in order of most importance: error, warning and then success';
function inputStatusChecker(_a) {
    var e_1, _b;
    var error = _a.error, warning = _a.warning, success = _a.success;
    var stateSet = false;
    try {
        for (var _c = __values(Object.values({ error: error, warning: warning, success: success })), _d = _c.next(); !_d.done; _d = _c.next()) {
            var value = _d.value;
            if (value) {
                if (stateSet) {
                    // eslint-disable-next-line no-console
                    console.error(_ErrorLogMessage);
                    return;
                }
                stateSet = true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
var ICON_STYLES = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  height: 1em;\n  width: 1em;\n"], ["\n  display: block;\n  height: 1em;\n  width: 1em;\n"])));
var SSuccessIcon = styled(SuccessIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ICON_STYLES);
var SWarningIcon = styled(WarningIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ICON_STYLES);
var SErrorIcon = styled(ErrorIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ICON_STYLES);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=extractInputStatusFromProps.js.map